export default [
  {
    path: '/pos/customer-orders',
    name: 'customer-display-orders',
    meta: { requiresAuth: false },
    component: () => import('@/pages/restaurant-order/customer-display-order.vue'),
  }
]
